import * as firebase from 'firebase/app'
import 'firebase/messaging'
import store from "../store"


function startFirebase() {
    firebase.initializeApp({
        apiKey: "AIzaSyBItD2TC9ivnLOeWaU5Fq1OalXgar26KxQ",
        authDomain: "gestao-agrisoy.firebaseapp.com",
        databaseURL: "https://gestao-agrisoy.firebaseio.com",
        projectId: "gestao-agrisoy",
        storageBucket: "gestao-agrisoy.appspot.com",
        messagingSenderId: "929298316129",
        appId: "1:929298316129:web:dbc849c8ba18c6f4"
    });

    if (!window.Notification) return false;

    if (Notification.permission === 'granted') {
        // Este código usa a API namespaced do Firebase v8 (firebase.messaging()).
        // No Firebase v9+ (o package.json hoje traz ^11) essa API foi removida, e o
        // throw síncrono daqui derrubava o boot inteiro do app. Enquanto o SDK não for
        // alinhado ao código (voltar ao v8 OU migrar para o modular v9), degradamos:
        // pulamos o FCM em vez de quebrar a aplicação.
        if (typeof firebase.messaging !== 'function') {
            console.warn('[FCM] firebase.messaging() indisponível nesta versão do SDK ' +
                '(código é v8, instalado é v9+). Push desativado; o restante do app segue normal.');
            return false;
        }

        const messaging = firebase.messaging();

        messaging.getToken()
            .then(token => {
                store.commit('changeFcmToken', token)
            })
            .catch(console.error);

        messaging.onTokenRefresh(() => {
            messaging.getToken()
                .then(token => {
                    store.commit('changeFcmToken', token)
                })
                .catch(console.error);
        });

        messaging.onMessage(payload => {
            store.commit('changeFcmData', payload);
        });
    } else {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            if (registrations) {
                registrations.forEach(r => {
                    if (r.active && /firebase-messaging-sw\.js$/) {
                        r.unregister()
                            .then(result => console.info('Unregister SW', result))
                            .catch(console.error);
                    }
                })
            }
        });
    }
}

export {
    startFirebase
}
